export const v19Properties = [
  "date",
  "scheduledTime",
  "arrivalTimeFrom",
  "arrivalTimeTo",

  "senderName",
  "senderAddress",
  "senderBuildingNumber",
  "senderPhone",
  "senderEmail",
  "senderNote",

  "recipientName",
  "recipientAddress",
  "buildingNumber",
  "recipientPhone",
  "recipientEmail",
  "dropOffNote",

  "parcelValue",
  "parcelWeight",
  "parcelDimensionsV2",

  "orderReferenceId",
]
